import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
const firebaseConfig = {
    apiKey: "AIzaSyBW7vHz7sLAzZTeMFxydJ0gJBcm5PoycRs",
    authDomain: "typingskill-c25c0.firebaseapp.com",
    projectId: "typingskill-c25c0",
    storageBucket: "typingskill-c25c0.appspot.com",
    messagingSenderId: "49806157083",
    appId: "1:49806157083:web:8a22a433d669cb77dc5fbe",
    measurementId: "G-0B8KMG6FYC"
  }; 

  const firebaseApp = firebase.initializeApp(firebaseConfig)
  const auth=firebase.auth()
  const db=firebase.firestore();
   export {auth,db};